// extracted by mini-css-extract-plugin
export var headline = "magazinMain-module--headline--ZFcb2";
export var title = "magazinMain-module--title--G2H1G";
export var body = "magazinMain-module--body--2DHUL";
export var articleContainer = "magazinMain-module--articleContainer--2c5Xw";
export var masonry = "magazinMain-module--masonry--To7nn";
export var item = "magazinMain-module--item--21dek";